import './index.css';
import { createAdminApp } from '@framework/index';
import createRecipeApi from './services/api';
import DashboardPage from './pages/DashboardPage';
import ImportPage from './pages/ImportPage';
import RecipesPage from './pages/RecipesPage';
import EncyclopediaPage from './pages/EncyclopediaPage';
import DocsPage from './pages/DocsPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import TierLimitsPage from './pages/TierLimitsPage';
import HelpArticlesPage from './pages/HelpArticlesPage';
import StoreRankingsPage from './pages/StoreRankingsPage';
import RecipeSitesPage from './pages/RecipeSitesPage';
import SitemapImportsPage from './pages/SitemapImportsPage';
import UsersPage from '@framework/pages/UsersPage';
import { ChefHat, LayoutDashboard, Users, BookOpen, UtensilsCrossed, BookOpenText, FileText, Megaphone, Sliders, HelpCircle, Search, Globe } from 'lucide-react';

createAdminApp({
  appName: 'Recipe Genie Admin',
  apiUrl: import.meta.env.VITE_API_URL || 'https://api-recipegenie.ioriented.com/api',
  brandColor: 'orange',
  logo: <ChefHat className="w-8 h-8 text-white" />,
  tagline: 'Admin Portal',
  requireRole: 'Administrator',
  navItems: [
    { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, component: DashboardPage },
    { key: 'import', label: 'Import Books', icon: BookOpen, component: ImportPage, admin: true },
    { key: 'recipes', label: 'Recipes', icon: UtensilsCrossed, component: RecipesPage, admin: true },
    { key: 'encyclopedia', label: 'Encyclopedia', icon: BookOpenText, component: EncyclopediaPage, admin: true },
    { key: 'announcements', label: 'Announcements', icon: Megaphone, component: AnnouncementsPage, admin: true },
    { key: 'tier-limits', label: 'Tier Limits', icon: Sliders, component: TierLimitsPage, admin: true },
    { key: 'help-articles', label: 'Help Articles', icon: HelpCircle, component: HelpArticlesPage, admin: true },
    { key: 'store-rankings', label: 'Store Rankings', icon: Search, component: StoreRankingsPage, admin: true },
    { key: 'recipe-sites', label: 'Recipe Sites', icon: Globe, component: RecipeSitesPage, admin: true },
    { key: 'sitemap-imports', label: 'Recipe Imports', icon: Globe, component: SitemapImportsPage, admin: true },
    { key: 'docs', label: 'System Docs', icon: FileText, component: DocsPage, admin: true },
    { key: 'users', label: 'Users', icon: Users, component: UsersPage, admin: true },
  ],
  createApiService: (apiUrl) => createRecipeApi(apiUrl),
});
